import AuthGuard from './AuthGuard.tsx';
import Button from './Button.tsx';
import infoCircle from '../assets/info_circle.svg';

import '../scss/quiz-auth-guard.scss';

type Props = {
  children: React.ReactNode;
  text?: string;
};

const QuizAuthGuard: React.FC<Props> = ({
  children,
  text = 'Prijavi se kako bi učestvovao u kvizu'
}) => {
  const handleLoginWithApp = () => {
    window.open(
      'http://ytl.rs/ya/yzt?utm_source=shopping.yettel.rs&utm_medium=button&utm_content=uloguj_se_na_app',
      '_blank'
    );
  };

  const additionalContent = (
    <div>
      <section className="bg-notification-beige border-radius-8 d-flex align-items-center pt-3 pb-3 ps-2 pe-2 mt-3 mb-2 ms-4 me-4">
        <img src={infoCircle} alt="info" />
        <article className="text-start ps-2 ms-4 me-4">
          Ne moraš da pamtiš šifru! Otvori Yettel aplikaciju i izaberi Yettel
          Shopping - odmah ćeš se vratiti na preuzimanje kupona kao prijavljen
          korisnik
        </article>
      </section>

      <Button onClick={handleLoginWithApp} secondary>
        <div className="pt-1 pb-1 fz-16">
          Prijavi se preko Yettel aplikacije
        </div>
      </Button>
    </div>
  );

  return (
    <AuthGuard
      text={text}
      className="quiz-auth-guard"
      additionalContent={additionalContent}
    >
      {children}
    </AuthGuard>
  );
};

export default QuizAuthGuard;
